import React, { useState } from "react";
import logo from "../images/logo1.png";
import { NavLink } from "react-router-dom";

const Navbar = () => {
    const [show, setShow] = useState(false);

    const closeMenu = () => {
        setShow(false);
    };

    return (
        <>
            <header className="himsal-navbar-wrapper">
                <nav className="himsal-navbar">

                    <div className="himsal-navbar-inner">

                        {/* =================================================
                            LOGO
                        ================================================= */}
                        <NavLink
                            exact
                            to="/"
                            onClick={closeMenu}
                            className="himsal-brand"
                        >
                            <img
                                src={logo}
                                alt="Himsal Services Pvt. Ltd."
                                className="himsal-logo"
                            />

                            <div className="himsal-brand-text">
                                <div className="himsal-brand-name">
                                    Himsal
                                </div>

                                <div className="himsal-brand-subtitle">
                                    SERVICES PVT. LTD.
                                </div>
                            </div>
                        </NavLink>

                        {/* =================================================
                            DESKTOP MENU
                        ================================================= */}
                        <div className="himsal-desktop-nav">

                            <NavLink
                                exact
                                to="/"
                                activeClassName="himsal-nav-active"
                                className="himsal-nav-link"
                            >
                                <span className="himsal-home-icon">
                                    <i
                                        className="fa fa-home"
                                        aria-hidden="true"
                                    />
                                </span>
                                Home
                            </NavLink>

                            <NavLink
                                to="/about"
                                activeClassName="himsal-nav-active"
                                className="himsal-nav-link"
                            >
                                About
                            </NavLink>

                            <NavLink
                                to="/service"
                                activeClassName="himsal-nav-active"
                                className="himsal-nav-link"
                            >
                                Services
                            </NavLink>

                            {/* CONTACT = ALWAYS CTA */}
                            <NavLink
                                to="/contact"
                                onClick={closeMenu}
                                className="himsal-contact-cta"
                            >
                                Contact Us
                            </NavLink>

                        </div>

                        {/* =================================================
                            MOBILE MENU BUTTON
                        ================================================= */}
                        <button
                            type="button"
                            className="himsal-menu-button"
                            onClick={() => setShow(!show)}
                            aria-label="Toggle navigation"
                            aria-expanded={show}
                        >
                            {show ? "✕" : "☰"}
                        </button>
                    </div>

                    {/* =================================================
                        MOBILE MENU
                    ================================================= */}
                    {show && (
                        <div className="himsal-mobile-nav">

                            <NavLink
                                exact
                                to="/"
                                onClick={closeMenu}
                                activeClassName="himsal-mobile-active"
                                className="himsal-mobile-link"
                            >
                                <i
                                    className="fa fa-home"
                                    aria-hidden="true"
                                />
                                Home
                            </NavLink>

                            <NavLink
                                to="/about"
                                onClick={closeMenu}
                                activeClassName="himsal-mobile-active"
                                className="himsal-mobile-link"
                            >
                                About
                            </NavLink>

                            <NavLink
                                to="/service"
                                onClick={closeMenu}
                                activeClassName="himsal-mobile-active"
                                className="himsal-mobile-link"
                            >
                                Services
                            </NavLink>

                            <NavLink
                                to="/contact"
                                onClick={closeMenu}
                                className="himsal-mobile-contact"
                            >
                                Contact Us
                            </NavLink>

                        </div>
                    )}
                </nav>
            </header>

            {/* =========================================================
                RESPONSIVE CSS
            ========================================================= */}
            <style>
                {`
                    /* =================================================
                       RESET
                    ================================================= */

                    .himsal-navbar-wrapper {
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        position: relative;
                        z-index: 1050;
                    }

                    .himsal-navbar {
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        background-color: #07162c;
                        border: none;
                        box-shadow: 0 4px 18px rgba(0,0,0,0.12);
                    }

                    .himsal-navbar-inner {
                        width: 100%;
                        max-width: 1200px;
                        min-height: 72px;
                        margin: 0 auto;
                        padding: 0 20px;

                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        box-sizing: border-box;
                    }

                    /* =================================================
                       BRAND
                    ================================================= */

                    .himsal-brand {
                        display: flex;
                        align-items: center;
                        gap: 10px;

                        text-decoration: none;
                        color: #ffffff;

                        flex-shrink: 0;
                    }

                    .himsal-brand:hover {
                        text-decoration: none;
                        color: #ffffff;
                    }

                    .himsal-logo {
                        width: 43px;
                        height: 43px;
                        object-fit: contain;
                        display: block;
                    }

                    .himsal-brand-text {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                    }

                    .himsal-brand-name {
                        color: #ffffff;
                        font-size: 20px;
                        font-weight: 800;
                        line-height: 1;
                        letter-spacing: -0.3px;
                    }

                    .himsal-brand-subtitle {
                        color: #94a3b8;
                        font-size: 9px;
                        font-weight: 600;
                        letter-spacing: 1.1px;
                        margin-top: 5px;
                        line-height: 1;
                    }

                    /* =================================================
                       DESKTOP NAV
                    ================================================= */

                    .himsal-desktop-nav {
                        display: flex;
                        align-items: center;
                        gap: 6px;
                    }

                    .himsal-nav-link {
                        position: relative;

                        display: flex;
                        align-items: center;
                        gap: 7px;

                        color: #cbd5e1;
                        text-decoration: none;

                        font-size: 15px;
                        font-weight: 600;

                        padding: 11px 15px;
                        border-radius: 8px;

                        transition:
                            color 0.2s ease,
                            background-color 0.2s ease;
                    }

                    .himsal-nav-link:hover {
                        color: #ffffff;
                        background-color: rgba(255,255,255,0.06);
                        text-decoration: none;
                    }

                    .himsal-nav-active {
                        color: #60a5fa !important;
                        background-color: rgba(37,99,235,0.13) !important;
                    }

                    .himsal-home-icon {
                        font-size: 14px;
                    }

                    /* =================================================
                       CONTACT CTA
                    ================================================= */

                    .himsal-contact-cta {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;

                        color: #ffffff !important;
                        background-color: #2563eb;

                        text-decoration: none;

                        font-size: 15px;
                        font-weight: 700;

                        padding: 12px 22px;
                        border-radius: 8px;

                        margin-left: 8px;

                        box-shadow:
                            0 6px 18px rgba(37,99,235,0.22);

                        transition:
                            background-color 0.2s ease,
                            transform 0.2s ease,
                            box-shadow 0.2s ease;
                    }

                    .himsal-contact-cta:hover {
                        background-color: #1d4ed8;
                        color: #ffffff !important;
                        text-decoration: none;

                        transform: translateY(-1px);

                        box-shadow:
                            0 8px 22px rgba(37,99,235,0.30);
                    }

                    /* =================================================
                       MOBILE BUTTON
                    ================================================= */

                    .himsal-menu-button {
                        display: none;

                        width: 42px;
                        height: 42px;

                        align-items: center;
                        justify-content: center;

                        background-color: transparent;

                        border: 1px solid rgba(255,255,255,0.18);
                        border-radius: 8px;

                        color: #ffffff;

                        font-size: 21px;
                        line-height: 1;

                        cursor: pointer;

                        padding: 0;
                    }

                    .himsal-menu-button:hover {
                        background-color: rgba(255,255,255,0.08);
                    }

                    /* =================================================
                       MOBILE NAV
                    ================================================= */

                    .himsal-mobile-nav {
                        display: none;
                    }

                    /* =================================================
                       TABLET
                    ================================================= */

                    @media (max-width: 850px) {

                        .himsal-navbar-inner {
                            min-height: 68px;
                        }

                        .himsal-desktop-nav {
                            display: none;
                        }

                        .himsal-menu-button {
                            display: flex;
                        }

                        .himsal-mobile-nav {
                            display: flex;

                            flex-direction: column;

                            width: 100%;

                            padding:
                                8px 20px
                                18px;

                            box-sizing: border-box;

                            border-top:
                                1px solid rgba(255,255,255,0.08);
                        }

                        .himsal-mobile-link {
                            width: 100%;
                            box-sizing: border-box;

                            color: #cbd5e1;

                            text-decoration: none;

                            font-size: 15px;
                            font-weight: 600;

                            padding: 13px 14px;

                            border-radius: 7px;

                            margin-bottom: 3px;
                        }

                        .himsal-mobile-link:hover {
                            color: #ffffff;
                            background-color:
                                rgba(255,255,255,0.06);

                            text-decoration: none;
                        }

                        .himsal-mobile-active {
                            color: #60a5fa !important;
                            background-color:
                                rgba(37,99,235,0.13) !important;
                        }

                        .himsal-mobile-contact {
                            width: 100%;
                            box-sizing: border-box;

                            display: flex;
                            align-items: center;
                            justify-content: center;

                            color: #ffffff !important;
                            background-color: #2563eb;

                            text-decoration: none;

                            font-size: 15px;
                            font-weight: 700;

                            padding: 13px 14px;

                            border-radius: 7px;

                            margin-top: 6px;
                        }

                        .himsal-mobile-contact:hover {
                            color: #ffffff !important;
                            background-color: #1d4ed8;
                            text-decoration: none;
                        }
                    }

                    /* =================================================
                       SMALL MOBILE
                    ================================================= */

                    @media (max-width: 480px) {

                        .himsal-navbar-inner {
                            min-height: 64px;
                            padding: 0 15px;
                        }

                        .himsal-logo {
                            width: 39px;
                            height: 39px;
                        }

                        .himsal-brand-name {
                            font-size: 18px;
                        }

                        .himsal-brand-subtitle {
                            font-size: 8px;
                            letter-spacing: 0.9px;
                        }

                        .himsal-menu-button {
                            width: 40px;
                            height: 40px;
                        }

                        .himsal-mobile-nav {
                            padding-left: 15px;
                            padding-right: 15px;
                        }
                    }
                `}
            </style>
        </>
    );
};

export default Navbar;
